import { useEffect, useState } from "react";

/**
 * Load project + snapshot list + selected snapshot for report documents.
 */
export function useReportSnapshot(projectId, snapshotId) {
  const [project, setProject] = useState(null);
  const [snapshots, setSnapshots] = useState([]);
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const pres = await fetch(`/api/projects/${encodeURIComponent(projectId)}`, { credentials: "include" });
        const pdata = await pres.json().catch(() => ({}));
        if (!pres.ok) throw new Error(pdata.error || "Failed to load project");
        if (cancelled) return;
        setProject(pdata.project);

        const sres = await fetch(`/api/projects/${encodeURIComponent(projectId)}/snapshots`, { credentials: "include" });
        const sdata = await sres.json().catch(() => ({}));
        if (!sres.ok) throw new Error(sdata.error || "Failed to load snapshots");
        const list = Array.isArray(sdata.snapshots) ? sdata.snapshots : [];
        if (cancelled) return;
        setSnapshots(list);

        const sid = snapshotId || (list[0]?.snapshotId ? String(list[0].snapshotId) : null);
        if (!sid) {
          setSnapshot(null);
          return;
        }
        const dres = await fetch(
          `/api/projects/${encodeURIComponent(projectId)}/snapshots/${encodeURIComponent(sid)}`,
          { credentials: "include" },
        );
        const ddata = await dres.json().catch(() => ({}));
        if (!dres.ok) throw new Error(ddata.error || "Failed to load snapshot");
        if (!cancelled) setSnapshot(ddata.snapshot);
      } catch (e) {
        if (!cancelled) setError(e?.message || "Failed to load report");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [projectId, snapshotId]);

  return { project, snapshots, snapshot, loading, error };
}

export function formatReportDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    return `${d.toISOString().slice(0, 19).replace("T", " ")} UTC`;
  } catch {
    return String(iso);
  }
}
